import * as React from 'react';
import styles from '../../MultiSelectSection/MultiSelectSection.module.scss';
import { ExtendedSelect } from '../../index';
import { IOption } from '../../Common/ExtendedSelect/ExtendedSelect';

const StatusSearch = <T extends string>(props: IProps<T>) => (
  <div className={styles.fields}>
      <div className={styles.field_title}>СТАТУС</div>
      <div className={styles.field_value}>
          <ExtendedSelect
            name={props.name || ''}
            value={props.value}
            options={props.options}
            onChange={e => props.onChange(e.value)}
            withoutDetectChanges
          />
      </div>
  </div>
);

interface IProps<T extends string> {
    name?: string;
    value?: T;
    options: IOption[];
    onChange: (value: string) => void;
}

export default StatusSearch;
